import { themeController, ControllerOptions } from "./themeController";

export const initTheme = (options?: ControllerOptions): void => {
  themeController.init(options);
  // Office populates context.officeTheme (and context.requirements) only after
  // onReady fires — which is AFTER this module evaluates. Re-resolve then so
  // "System" can follow the Office theme instead of only prefers-color-scheme.
  // Non-Office pages have no Office.onReady and simply skip this.
  try {
    const O = (window as any).Office;
    if (typeof O?.onReady === "function") {
      O.onReady().then(() => themeController.refresh()).catch(() => { /* noop */ });
    }
  } catch { /* noop */ }
};

const reveal = () => {
  try { document.documentElement.classList.remove("theme-pending"); } catch { /* noop */ }
};

// Reveal the gated shell when Office is ready, on failure, or after a hard timeout —
// so a hung/failed Office.onReady can never leave a blank pane.
export const revealWhenReady = (ready: Promise<unknown>, timeoutMs = 2500): void => {
  let done = false;
  const once = () => { if (!done) { done = true; reveal(); } };
  const t = setTimeout(once, timeoutMs);
  Promise.resolve(ready).catch(() => undefined).finally(() => { clearTimeout(t); once(); });
};
